import React from 'react';
import { ConnectProvider } from './context.esm.js';

var Connect = function Connect(_ref) {
  var authOptions = _ref.authOptions,
      children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(ConnectProvider, {
      authOptions: authOptions
    }, children)
  );
};

export { Connect };